export function trimValues(data) {
  for (var k in data) {
    var v = data[k]
    if (
      typeof v == 'string' &&
      v.charAt(0) == ',' &&
      v.charAt(v.length - 1) == ','
    ) {
      data[k] = v.substr(1, v.length - 2)
    }
  }
}
